import { Controller } from '@hotwired/stimulus'

// Lets the user pick how many rows tall the (internally-scrolling) table
// should be, via a CSS custom property the wrapper's max-height is built from.
export default class extends Controller {
  static targets = ['wrapper']

  set(event) {
    this.wrapperTarget.style.setProperty('--data-table-visible-rows', event.target.value)
  }
}
